import { Box, Stack, Typography } from '@mui/material';
import ChevronRight from '@mui/icons-material/ChevronRight';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { SettingsConfig } from './SettingsAccordionConfig';
import { useActivePersona } from '@/personas/useActivePersona';

/**
 * "Byt karaktär"-åtgärd i inställningarna: navigerar till /onboarding så att
 * barnet kan välja om/namnge sin kompanjon. Visas ENBART för persona 'child'
 * (self-hides annars) så att vuxen/handledare/ungdom aldrig ser den.
 *
 * Gaten går på PERSONA, inte på childMode: teen nås bara med childMode på
 * (resolveActiveProfile kräver effectiveChildMode för både child och teen), så
 * isChildModeEnabled() svarade ja även för ungdom och lämnade kvar "Byt kompis"
 * efter ett byte barn→ungdom. Samma villkor som kompis-sektionen i
 * SettingsPage.tsx använder — en sanning för hela kompis-ytan.
 *
 * Renderas som toggleComponent (samma rad-stil som DarkModeToggle) men utan
 * Switch — en klickbar rad med chevron.
 */
const ChangeCharacterSetting = (props: SettingsConfig) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { persona } = useActivePersona();

  // toggleComponent måste returnera ett JSX.Element (ej null) → tomt fragment när av.
  if (persona !== 'child') return <></>;

  return (
    <Box sx={{ p: 2, display: 'flex', alignItems: 'center', width: '100%' }}>
      <Stack
        justifyContent={'space-between'}
        direction={'row'}
        width={'100%'}
        alignItems={'center'}
        sx={{ cursor: 'pointer' }}
        onClick={(e) => {
          e.stopPropagation();
          navigate('/onboarding');
        }}
      >
        <Typography variant="h6" color={'primary'}>
          {t(props.title)}
        </Typography>
        <ChevronRight color="primary" />
      </Stack>
    </Box>
  );
};

export default ChangeCharacterSetting;
